import { render, staticRenderFns } from "./pushrecord.vue?vue&type=template&id=c1d46912&scoped=true"
import script from "./pushrecord.vue?vue&type=script&lang=js"
export * from "./pushrecord.vue?vue&type=script&lang=js"
import style0 from "./pushrecord.vue?vue&type=style&index=0&id=c1d46912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d46912",
  null
  
)

export default component.exports